export const RECENTLY_VIEWED_URL = '/rest/issueNav/1/history/saveFilter/';
